import React, {  useEffect, useState } from 'react';
import { BetDetails, ParlayDetails, TeaserDetail } from '../../../models/MyBetModel.tsx';
import { getUserBets } from '../../../services/player/BetService.tsx';
import PendingBetComponent from '../pendig/PendingBetComponent.tsx';
import { Timestamp } from 'firebase/firestore';
import { useUser } from '../../../context/UserContext.tsx';
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";


function WeekCalendarComponent() {

    const { user } = useUser();
    const [userBet, setUserBet] = useState<(BetDetails | ParlayDetails | TeaserDetail)[]>([]);
    const [displayedDate, setDisplayedDate] = useState(new Date());

    const getWeekRange = (date: Date): { from: Date, to: Date } => {
        const startOfWeek = new Date(date);
        startOfWeek.setDate(date.getDate() - date.getDay());
        const endOfWeek = new Date(date);
        endOfWeek.setDate(date.getDate() + (6 - date.getDay()));
        return { from: startOfWeek, to: endOfWeek };
    };

    const { from, to } = getWeekRange(displayedDate);

    const formatDay = (date: Date): string => {
        const day = date.toLocaleDateString('en-US', { day: 'numeric' });
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        return `${day}-${month}`;
    };

    const handleNextWeek = () => {
        const nextWeek = new Date(displayedDate);
        nextWeek.setDate(nextWeek.getDate() + 7);
        setDisplayedDate(nextWeek);
    };

    const handlePrevWeek = () => {
        const prevWeek = new Date(displayedDate);
        prevWeek.setDate(prevWeek.getDate() - 7);
        setDisplayedDate(prevWeek);
    };

    const loadBets = async () => {
        const usersBets = await getUserBets(user?.userName ?? '', Timestamp.fromDate(from), Timestamp.fromDate(to));
        setUserBet(usersBets);
    }
    useEffect(() => {
        loadBets();
    }, [displayedDate]);

    const totalWeeklyBets = userBet.reduce((total, bet) => total + (bet.reward || 0), 0);

    return (
        <>
            <div>
                <div className="flex-container">
                    <div className='container-week'>
                        <button className="img-calendar" onClick={handlePrevWeek}>
                            <IoIosArrowBack />
                        </button>
                        <span className="date-week">{`${formatDay(from)} to ${formatDay(to)}`}</span>
                        <button className="img-calendar-week" onClick={handleNextWeek}>
                            <IoIosArrowForward />
                        </button>
                    </div>

                    <div className='title-total'>
                        <span className="title-container">
                            TOTAL: <span className="additional-text">+ {totalWeeklyBets}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <div className='header-pending'>
                <div className='description-container'>
                    <span className='table-letters'>DESCRIPTION</span>
                </div>
                <div className='risk-container'>
                    <span className='table-letters'>RISK</span>
                </div>
                <div className='reward-container'>
                    <span className='table-letters'>REWARD</span>
                </div>
            </div>
                {userBet.length > 0 && (
                    <div className="pending-list ">
                        {userBet.map((bets, key) => (
                            <div key={key}  className="pending-body">
                                <PendingBetComponent {...bets} />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>

    )
}
export default WeekCalendarComponent;